import { ProjectViewContent } from '@components/ProjectViewContent'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  Files,
  Grid,
  ListTree,
  Pulse,
  Thumbnail,
} from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { useArtboardMode, useGetDashboardUrl, useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'
import { FileContent } from '../FileContent'
import { ProjectIconMenu } from '../ProjectIconMenu'

export const MenuContent = () => {
  const url = useGetDashboardUrl()
  const { hasAccess, hasNotAvailableAccess, hasNotAvailableAccessBadge } =
    useProjectAccess(PROJECT_SETTINGS_PERMISSION.ACTIVITY_HISTORY_TAB)

  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  // SEO mode has its own right-hand sidebar and hides the Structure button.
  const { seoMode } = useArtboardMode()

  const { hasNotAvailableAccess: attachedFilesDisabled } = useProjectAccess(
    PROJECT_SETTINGS_PERMISSION.ATTACHED_FILES_TAB
  )

  const attachesDisabled = attachedFilesDisabled || !canEdit

  return (
    <>
      <DropdownMenu.Link icon={Grid} title="Go to Dashboard" to={url} />
      <DropdownMenu.Divider />
      <DropdownMenu.NestedMenu content={FileContent} id="file" title="File" />
      <DropdownMenu.NestedMenu
        content={ProjectViewContent}
        id="view"
        title="View"
      />
      {!seoMode && (
        <DropdownMenu.Button icon={ListTree} id="structure" title="Structure" />
      )}
      <DropdownMenu.Divider />
      <DropdownMenu.NestedMenu
        content={ProjectIconMenu}
        icon={Thumbnail}
        id="project_icon"
        title="Project icon"
      />
      {hasNotAvailableAccessBadge && (
        <DropdownMenu.BadgedButton
          icon={Pulse}
          id="activity_upgrade"
          title="Activity history"
          type="pro"
        />
      )}
      {hasAccess && (
        <DropdownMenu.Button
          disabled={hasNotAvailableAccess}
          icon={Pulse}
          id="activity_history"
          title="Activity history"
        />
      )}
      <DropdownMenu.Button
        icon={Files}
        id="attached_files"
        title="Attached files"
        disabled={attachesDisabled}
      />
    </>
  )
}
